import { useMemo } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import ClassicLightTheme from 'foundations-theming/themes/classic/light/theme';
import NextLightTheme from 'foundations-theming/themes/next/light/theme';
import NextDarkTheme from 'foundations-theming/themes/next/dark/theme';

// TODO: consider adding a discriminated union since `classic` only has
// a `light` mode, whereas `next` support both `light/dark`.
import { jsx as _jsx } from "react/jsx-runtime";
// TODO: enable dynamic imports for loading themes on demand.
// E.g. https://git.hubteam.com/errodriguez/hds-components-prototypes/blob/master/src/theming-experiment/ExperimentalAppProvider.tsx#L37-L46
const getTheme = (themeName, themeMode) => {
  if (themeName === 'classic') {
    if (themeMode === 'light') {
      return ClassicLightTheme;
    }
  } else if (themeName === 'next') {
    if (themeMode === 'light') {
      return NextLightTheme;
    } else {
      return NextDarkTheme;
    }
  }
  throw new Error('Unsupported theme and mode combination.');
};

/**
 * The `ThemeProvider` provides the theme object for your app via
 * React Context. Foundations components **will not work without it**.
 * This `ThemeProvider` is used by the `AppProvider` component,
 * which is the top-level component that should wrap your entire app.
 * However, it can also be used on its own lower in your component tree
 * if you need to override the theme for a specific subtree. This could
 * be useful for opt-in user testing purposes.
 *
 * This component is also used by `hs-test-utils` to wrap all unit test
 * component trees.
 */
export const ThemeProvider = ({
  themeName = 'classic',
  themeMode = 'light',
  children
}) => {
  // Because this component is used by `hs-test-utils` to wrap all unit test component
  // trees, `React.useState` cannot be used in this component until incorrect usage of
  // spies in tests across our frontend apps is resolved.

  const theme = useMemo(() => getTheme(themeName, themeMode), [themeName, themeMode]);
  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: theme,
    children: children
  });
};